// Format.Ref — version-level reference to a format registry entry.
//
// The discriminant `format_ref` is globally unique per the standing
// rule, but Format is a reference-only registry (not a KB assertion
// subject/object) so `Format.Ref` deliberately stays *outside* the
// top-level `EntityRef` sum.
export { mk };
const mk = (id, version) => ({
    type: "format_ref",
    id,
    version,
});
//# sourceMappingURL=ref.js.map